export enum MingaAudio {
  POSITIVE_PING = '/assets/audio/positive-ping.wav',
  NEGATIVE_PING = '/assets/audio/negative-ping.wav',
  HALL_PASS_PING = '/assets/audio/hall-pass-ping.mp3',
}
